export const StorageParams = {
  AuthReducer: 'authReducer',
  Language: 'language',
  Path: 'path',
  TrackingCompany: 'trackingCompany',
  UserId: 'userId'
}